import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { useBrandsSlice } from 'entities/Brand';
import { EFilters } from 'features/Filters';
import { EMainRoutes } from 'shared/typings';
import { ButtonStyleLink } from 'shared/ui';

interface IJoinedSourceLinksProps extends HTMLAttributes<HTMLDivElement> {
	sourceUuid: string;
	offerUuid: string;
	count: number;
}

export const JoinedSourceLinks: FC<IJoinedSourceLinksProps> = ({ sourceUuid, offerUuid, count }) => {
	const { t } = useTranslation();
	const { setOpenedOffer } = useBrandsSlice();

	return (
		<ButtonStyleLink
			to={`/${EMainRoutes.LINKS}/?${EFilters.SOURCE_ID}=${sourceUuid}&${EFilters.OFFER_ID}=${offerUuid}`}
			onClick={() => setOpenedOffer(null)}>
			{t('Ссылки')}: {count}
		</ButtonStyleLink>
	);
};
